import { useContext, useMemo, useRef, type FC } from 'react';
import { useSelector } from 'react-redux';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import StudioHeaderMobile from '../../../components/StudioHeaderMobile';
import CoreBannerMobile from '../CoreBannerMobile/CoreBannerMobile';
import PlaygroundTabs from '../../../components/playground/PlaygroundTabs';
import { getVideoCreatorRestrictions } from '../../../selectors/studio';
import VideoCreatorControls from '../VideoCreatorControls';
import VideoCreatorFiles from '../VideoCreatorFiles';

import s from './VideoCreatorMobile.scss';

const VideoCreatorMobile: FC = () => {
  const { hasCoreMembership } = useContext(SessionContext);
  const { videoPromptsRemaining } = useSelector(getVideoCreatorRestrictions);
  const showCoreBanner = useMemo(() => {
    if (!hasCoreMembership) {
      return videoPromptsRemaining < 1;
    } else {
      return false;
    }
  }, [hasCoreMembership, videoPromptsRemaining]);

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={scrollContainerRef} className={s['root']}>
      <div className={s['header']}>
        <StudioHeaderMobile navOnly={true} />
      </div>
      <div className={s['main']}>
        <PlaygroundTabs className={s['playground-tabs']} />
        {showCoreBanner && <CoreBannerMobile />}
        <VideoCreatorControls />
        <VideoCreatorFiles scrollContainerRef={scrollContainerRef} />
      </div>
    </div>
  );
};

VideoCreatorMobile.displayName = 'VideoCreatorMobile';

export default VideoCreatorMobile;
